import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import useTheme from '@eversports/klimt-design-components/use-theme'
import Dialog, { DialogContent } from '@eversports/klimt-primitives/legacy/Dialog'

import FullscreenDialog from '../../../../../../components/FullscreenDialog'
import { Localized } from '../../../../../../localization/react'

import SearchContent from './SearchContent'

interface Props {
  isOpen: boolean
  toggleDialog: () => void
}

const Search = ({ isOpen, toggleDialog }: Props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return isMobile ? (
    <FullscreenDialog title={<Localized id="find-new-friends-title" />} isOpen={isOpen} onClose={toggleDialog}>
      <SearchContent />
    </FullscreenDialog>
  ) : (
    <Dialog open={isOpen} onClose={toggleDialog}>
      <DialogContent sx={{ height: '672px', padding: 0 }}>
        <SearchContent />
      </DialogContent>
    </Dialog>
  )
}

export default Search
